module.exports = __webpack_public_path__ + "media/images/common/3column_product_bg_nnx-d103eb573faef5cd7362332d5ef71f0a.png";